module.exports = __webpack_public_path__ + "static/media/overview_bg.3d27d2b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/branding/nobrand/overview_bg.jpg
// module id = 1109
// module chunks = 0